import axios from "axios";
import { APIConstants, APILimit } from "../../constants/ApiConstants";

export const getMerchant = async (filters?: string) => {
  let baseURl = `${process.env.REACT_APP_API_URL + APIConstants.getMerchant}`;
  if (filters) {
    baseURl += `?${filters}`;
  }
  try {
    const response = await axios.get(`${baseURl}`);
    return response.data?.response?.organization?.entities?.entity;
  } catch {
    return [];
  }
};
